import { C1Chip } from 'c1ui/components/C1Chip'
import { userStatusToIdentifier } from 'components/pages/user/type'
import { UserStatus } from 'pbts/c1/api/user/v1/user'
import { useIntl } from 'react-intl'

type UserStatusDisplayProps = {
    status?: UserStatus
}

export const UserStatusDisplay = ({ status }: UserStatusDisplayProps): React.ReactElement => {
    const intl = useIntl()
    const identifierProps = userStatusToIdentifier(status, intl)

    return <C1Chip label={identifierProps.label} color={identifierProps.color} />
}
